const ActionType = {
  UPLOAD_IMAGE: "UPLOAD_IMAGE",
  FETCH_IMAGE: "FETCH_IMAGE",
  SAVE_IMAGE: "SAVE_IMAGE",
  DELETE_IMAGE: "DELETE_IMAGE",
  FETCH_BUSINESS_IMAGES: "FETCH_BUSINESS_IMAGES",
  UPLOAD_PUBLIC_IMAGE: "UPLOAD_PUBLIC_IMAGE",
  DELETE_MULTIPLE_FILES: "DELETE_MULTIPLE_FILES",
  SET_MEDIA_DATA: "SET_MEDIA_DATA",
};

export default ActionType;

export const UPLOAD_IMAGE_REQUEST ='UPLOAD_IMAGE';
export const FETCH_IMAGE_REQUEST ='FETCH_IMAGE_REQUEST';
export const SAVE_IMAGE_REQUEST = 'SAVE_IMAGE_REQUEST';
export const FETCH_IMAGE_SUCCESS='FETCH_IMAGE_SUCCESS';
export const FETCH_IMAGE_FAILURE ='FETCH_IMAGE_FAILURE'